import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sc-errors',
  templateUrl: './errors.component.html',
  styleUrls: ['./errors.component.css']
})
export class ErrorsComponent implements OnInit {
  constructor() {}

  public ngOnInit(): void {}
}
